import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin, 
  FaTwitter, 
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          <Col md={4} className="footer-col">
            <h6 className="footer-title">ОШТУ Сообщество</h6>
            <p className="footer-about">
              Объединяем выпускников ОШТУ. Сохраняем традиции, строим будущее.
            </p>
            {/* 
             */}
          </Col>

          <Col md={2} sm={6} className="footer-col">
            <h6 className="footer-title">Навигация</h6>
            <ul className="footer-links">
              <li><Link to="/">Главная</Link></li>
              <li><Link to="/about">О нас</Link></li>
              <li><Link to="/news">Новости</Link></li>
            </ul>
          </Col>

          <Col md={2} sm={6} className="footer-col">
            <h6 className="footer-title">Сообщество</h6>
            <ul className="footer-links">
              <li><Link to="/alumni">Выпускникам</Link></li>
              <li><Link to="/partners">Партнеры</Link></li>
              <li><Link to="/contact">Контакты</Link></li>
            </ul>
          </Col>

          <Col md={4} className="footer-col">
            <h6 className="footer-title">Контакты</h6>
            <ul className="footer-contacts">
              <li><FaMapMarkerAlt /> Кыргызстан, г. Ош, ул. Исанова 81</li>
              <li><FaEnvelope /> oshtu.adyshev@mail.ru</li>
              <li><FaPhone /> (+996 3222) 4 3883</li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col className="text-center copyright">
            © {new Date().getFullYear()} ОШТУ Сообщество выпускников.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
